import { getPetDetailApi } from "@front/apis"

import { loadSelectedPet, setSelectedPet } from "@front/store"
import { store } from "@front/store"

const setPet = async (petGUID: string) => {
  if (!petGUID) return
  const dispatch = store.dispatch
  const res = await getPetDetailApi({ guid: petGUID || '' })
  dispatch(setSelectedPet(petGUID || ''))
  dispatch(
    loadSelectedPet({
      name: res.data.name,
      guid: res.data.guid,
      ageByMonths: res.data.ageByMonths,
      avatar: res.data.avatar,
      birthday: res.data.birthday,
      detailDataProgress: res.data.detailDataProgress,
      hasInsurance: res.data.hasInsurance,
      hasAllVaccines: res.data.hasAllVaccines,
      hasDocument: res.data.hasDocument,
      isSterilised: res.data.isSterilised,
      microchip: res.data.microchip,
      microchipStatus: res.data.microchipStatus,
      insuranceStatus: res.data.insuranceStatus,
      documentsStatus: res.data.documentsStatus,
      isVaccinated: res.data.isVaccinated,
      petBreed: {
        guid: res.data.petBreedGUID ?? '',
        name: res.data.petBreedName,
      },
      fatherBreed: {
        guid: res.data.fatherBreedGUID ?? '',
        name: res.data.fatherBreedName ?? '',
      },
      motherBreed: {
        guid: res.data.motherBreedGUID ?? '',
        name: res.data.motherBreedName ?? '',
      },
      petType: {
        guid: res.data.petTypeGUID,
        name: res.data.petTypeName ?? '',
      },
      qrCode: res.data.qrCode,
      weight: res.data.weight,
      character: res.data.character,
      hairColor: res.data.hairColor,
      hairLength: res.data.hairLength,
      locatorActivationCode: res.data.locatorActivationCode,
      allowPkpass: res.data.allowPkpass,
      gender: res.data.gender,
    }),
  )
}

export { setPet }